import LivestockShrinkCalculate from './LivestockShrinkCalculate'

export default LivestockShrinkCalculate
